module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph1"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph1"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("Revenge is a kind of wild justice;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("which the more man’s nature runs to,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("the more ought law to weed it out.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph2"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Francis Bacon, 1st Baron Verulam"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("‘On Revenge’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7707df4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Epigraph.vue
// module id = 72
// module chunks = 0